import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    context: 'patient',
    path: '_id',
    viewPath: props.viewPath,
  })

  return {
    requestPolicy: 'network-only',
    variables: {
      patient_id,
    },
  }
}
